import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../layout/SectionTitle';

const Presentation = () => {
  const { t } = useTranslation();

  return (
    <section className="py-8 bg-white">
      <div className="container mx-auto px-4 relative">
        {/* Bloc rouge en arrière-plan */}
        <div className="absolute -bottom-12 left-0 w-full h-[300px] md:h-[400px] bg-socabeg-red rounded-md shadow-lg -z-10">
          {/* Contenu vide avec fond rouge */}
        </div>
        
        {/* Titre de la section */}
        <SectionTitle 
          overline={t('mining.presentation.title')} 
          highlight={t('mining.presentation.subtitle')} 
          separatorColor="socabeg-blue" 
          showLogo={true} 
        />
        
        {/* Contenu principal */}
        <div className="relative grid md:grid-cols-2 gap-4 md:gap-8 mt-6">
          {/* Colonne Gauche */}
          <div className="space-y-3 text-sm md:text-base leading-relaxed">
            <p className="text-justify">{t('mining.presentation.about.paragraph1')}</p>
          </div>

          {/* Colonne Droite */}
          <div className="space-y-3 text-sm md:text-base leading-relaxed">
            <p className="text-justify">{t('mining.presentation.about.paragraph2')}</p>
          </div>
        </div>
        
        {/* Bandeau visuel sous les colonnes avec image de fond */}
        {/* Version mobile : rectangle bleu au-dessus puis image en dessous */}
        <div className="mt-8 md:mt-16 rounded-lg shadow-lg overflow-hidden block md:hidden">
          <div className="bg-socabeg-blue text-white px-6 py-8">
            <div className="space-y-4 text-sm leading-relaxed">
              <p className="text-justify">{t('mining.presentation.blue.paragraph1')}</p>
              <p className="text-justify">{t('mining.presentation.blue.paragraph2')}</p>
              <p className="text-justify">{t('mining.presentation.blue.paragraph3')}</p>
            </div>
          </div>
          <div className="mt-4">
            <img
              src="/images/mine1.png"
              alt="Présentation SOCABEG Mining"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>

        {/* Conteneur pour l'image pleine largeur et le bloc bleu */}
        <div className="relative mt-12 mb-8 hidden md:block">
          {/* Image pleine largeur */}
          <div className="w-screen" style={{ height: '500px', marginLeft: 'calc(-50vw + 50%)' }}>
            <div className="h-full w-full">
              <img 
                src="/images/mine1.png" 
                alt="Présentation SOCABEG Mining" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          
          {/* Div bleu */}
          <div 
            className="bg-socabeg-blue text-white rounded-lg" 
            style={{
              position: 'absolute',
              left: '0',
              top: '0',
              width: '40%',
              height: 'auto',
              minHeight: 'clamp(250px, 70%, 350px)',
              padding: '1rem',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              transform: 'translateY(-10%)'
            }}
          >
            <div className="text-xs sm:text-sm md:text-base leading-normal space-y-3 overflow-auto h-full">
              <p className="text-justify font-medium">{t('mining.presentation.blue.paragraph1')}</p>
              <p className="text-justify font-medium">{t('mining.presentation.blue.paragraph2')}</p>
              <p className="text-justify font-medium">{t('mining.presentation.blue.paragraph3')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Presentation;
